///
/// EarthBrowser
///
/// Created by Matt Giger on 1/13/2025
/// Copyright (c) 2025 Geodata Labs
///

import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
import type { CookieSettings } from "@shared-types/user"
import type { UserRecordEntry } from "@shared-types/user"

interface UserState {
	userProfile?: UserRecordEntry
	cookieSettings: CookieSettings
}

const initialState: UserState = {
	userProfile: undefined,
	cookieSettings: {
		performance: true,
		personalization: true,
	},
}

export const userSlice = createSlice({
	name: "user",
	initialState,
	reducers: {
		setUserProfile: (state, action) => {
			state.userProfile = action.payload as UserRecordEntry | undefined
		},
		setCookieSettings: (state, action: PayloadAction<CookieSettings>) => {
			state.cookieSettings = action.payload
		},
	},
})

export const {
	setUserProfile,
	setCookieSettings,
} = userSlice.actions
